import ValidaTexto from '../../validadores/ValidaTexto';

export default class ValidaNarrativa {
    
    static valida(_narrativa) {

        return new Promise((resolve,reject) => {
            try {
                const narrativa = validarNarrativa(_narrativa)
                resolve(narrativa)
            } 
            catch (msgErro) {
                reject(msgErro)
            }
        })
    }
}

const validarNarrativa = _narrativa => {
    try {
        let narrativa = ValidaTexto.valida(
            _narrativa,
            'Narrativa',
            false,
            1000000 // Um MEGA BYTES
        );

        narrativa = acrescentarPularLinhaHtml(narrativa)
        return narrativa
    } 
    catch (msgErro) {
        throw obterMsgErro(msgErro.texto);
    }
}

const obterMsgErro = msgErro => {
    return ({ status:400, tipo:'problema', texto:msgErro });
}

const acrescentarPularLinhaHtml = _texto => {
    const tamTexto = _texto.length;
    let textoHtml = '';
    let carInt = null;
    let carStr = null;
    let ultCarInt = null;
    for (let i=0;i<tamTexto;i++) {
        carInt = _texto.charCodeAt(i);
        carStr = _texto.charAt(i);
        if (carInt < 32) carStr = '<br />';
        if (ultCarInt === 32 && carInt === 32) continue;
        textoHtml += carStr; 
        ultCarInt = carInt;
    }

    return textoHtml;
}